export default "__VITE_ASSET__GjU1Oib58UYo7ynzIb01Rg__"